<template>
  <div class="flex content">
    <div class="open">
      <p class="open1" @click="open">
        {{type}}
      </p>
      <span class="save">保存志愿</span>
    </div>
    <div class="zhuanye" v-show="type!='展开志愿表'">
      <div v-for="(item,index) in data" :key="index">
        <div class="flex" style="justify-content: space-between;margin: 10px 0;"><span
            class="no">{{index+1}}</span>{{item.school_name}}<i class="el-icon-delete"></i></div>
        <div class="flex" style="flex-wrap: nowrap;align-items: flex-start;">
          <p v-for="(item1,index1) in item.major" :key="index1">{{index1+1}}.{{item.major_name}}</p><i
            class="el-icon-delete"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: '展开志愿表'
      }
    },
    created() {

    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    methods: {
      open() {
        if (this.type == '展开志愿表') {
          this.type = '收起志愿表'
        } else {
          this.type = '展开志愿表'
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  .zhuanye {
    width: 200px;
    border: 1px solid #ccc;
    border-left: none;
    min-height: 218px;
    background-color: #FFFFFF;
    padding: 0 10px;

    p {

      word-break: break-word;
      border-bottom: 1px solid #ccc;
      text-align: left;

      padding-bottom: 10px;
    }
  }

  .no {
    background-color: #C10B17;
    padding: 4px 6px;
    border-radius: 3px;
    color: #FFFFFF;
  }

  .content {
    position: fixed;
    top: 500px;
    right: 0;
  }

  .open {
    width: 46px;
    height: 277px;
    // background: #FFFFFF;
    border: 1px solid #C10B17;
    border-radius: 10px 0px 0px 10px;
    width: 45px;
    height: 218px;
    background: #C10B17;
    border-radius: 10px 0px 0px 10px;
    color: #FFFFFF;
    border-bottom-left-radius: 0px;
    cursor: pointer;

    .open1 {
      line-height: 15px;
      letter-spacing: 5px;
    }

    .save {
      display: inline-block;
      width: 100%;
      background-color: #FFFFFF;
      color: #C10B17;
      height: 50px;
      line-height: 25px;
      margin-top: 10px;
    }

    p {
      text-align: center;
      margin: 28px 0 25px 15px;
      writing-mode: vertical-lr
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/open.vue